<tds-message [variant]="message?.type" [header]="message?.header">
  <br>{{ message?.content }}
</tds-message>